import { useState, useEffect, ReactNode } from "react";
import loadingWheel from "../../assets/loading.svg";
import useRefreshToken from "../../hooks/useRefreshToken";
import { useAuth } from "../../hooks/useAuth";
import { Outlet } from "react-router-dom";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const refresh = useRefreshToken();
    const auth = useAuth();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            }
            catch (err) {
                console.error(err);
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }

        if ((auth?.accessToken == "") && auth?.persist) {
            verifyRefreshToken();
        } else {
            setIsLoading(false);
        }

        return () => { isMounted = false; };
    }, []);

    return (
        <>
            {!auth?.persist
                ? <Outlet />
                : isLoading
                    ? <div className="flex fixed z-[1000] backdrop-blur-md h-full w-full items-center justify-center">
                        <img src={loadingWheel} alt="" className="w-20 h-20" />
                       </div>
                    : <Outlet />
            }
        </>
    );
}

export default PersistLogin;